/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface OptOutRequestBase
 */
export interface OptOutRequestBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestBase
   */
  doNotSend?: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestBase
   */
  token?: string;
}

export interface OptOutRequestBase extends OptOutRequestBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestBase
   */
  doNotSend?: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestBase
   */
  token?: string;
}

export interface OptOutRequestBaseTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestBase
   */
  doNotSend?: boolean;
  doNotSendIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestBase
   */
  token?: string;
  tokenIsSet: boolean;
}

transformDatesMap.set(
  "OptOutRequestBase",
  function (model: OptOutRequestBase) {},
);

export type OptOutRequestBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  doNotSend: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  token: PropertyMeta<MetaTypeBase<string>>;
}>;

export var OptOutRequestBaseMeta: OptOutRequestBaseMetaI =
  {} as OptOutRequestBaseMetaI;
OptOutRequestBaseMeta = typeMeta("OptOutRequestBase", {
  doNotSend: propertyMeta(
    "doNotSend",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  token: propertyMeta("token", false, false, false, MetaTypesBase.string),
});

const metaI = OptOutRequestBaseMeta;

registerMeta(() => {});

export class OptOutRequestBaseTracked implements OptOutRequestBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  doNotSend__I?: boolean = undefined;
  doNotSendIsSet: boolean = false;
  set doNotSend(v: undefined | boolean) {
    if (v !== undefined) {
      this.doNotSend__I = v;
      this.doNotSendIsSet = true;
    } else {
      this.doNotSend__I = v || undefined;
      this.doNotSendIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotSend() {
    return this.doNotSend__I;
  }
  token__I?: string = undefined;
  tokenIsSet: boolean = false;
  set token(v: undefined | string) {
    if (v !== undefined) {
      this.token__I = v;
      this.tokenIsSet = true;
    } else {
      this.token__I = v || undefined;
      this.tokenIsSet = false;
    }
    this.changeTracker = true;
  }
  get token() {
    return this.token__I;
  }
  constructor(config?: OptOutRequestBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: OptOutRequestBaseOptional,
    options?: AssignOptions,
  ): OptOutRequestBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.doNotSend && this.doNotSendApplyFilter(optionsRequired.filter)) {
      this.doNotSend = config.doNotSend;
      if (optionsRequired.unassign) this.doNotSendIsSet = false;
      else this.doNotSendIsSet = true;
    }
    if (config.token && this.tokenApplyFilter(optionsRequired.filter)) {
      this.token = config.token;
      if (optionsRequired.unassign) this.tokenIsSet = false;
      else this.tokenIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OptOutRequestBaseTrackedI {
    const cloned = {} as OptOutRequestBaseTrackedI;
    if (
      this.doNotSendIsSetDeep() &&
      this.doNotSendApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotSendIsSet = true;
      cloned.doNotSend = this.doNotSend;
    } else {
      //cloned.doNotSendIsSet = false
    }
    if (
      this.tokenIsSetDeep() &&
      this.tokenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tokenIsSet = true;
      cloned.token = this.token;
    } else {
      //cloned.tokenIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OptOutRequestBaseTrackedI {
    if (!this.doNotSendApplyFilter(filter)) this.doNotSendIsSet = false;

    if (!this.tokenApplyFilter(filter)) this.tokenIsSet = false;

    return this;
  }
  doNotSendApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestBaseMeta.doNotSend,
      OptOutRequestBaseMeta,
      this.doNotSend,
      this,
    );
  }
  doNotSendIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotSendIsSet && this.doNotSendApplyFilter(filter)) return true;

    return false;
  }
  tokenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestBaseMeta.token,
      OptOutRequestBaseMeta,
      this.token,
      this,
    );
  }
  tokenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tokenIsSet && this.tokenApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.doNotSendIsSetDeep(filter)) return true;
    if (this.tokenIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
